import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AccessDeniedPageComponent} from './access-denied-page.component';
import {GenericLinkModule, MediaModule,} from '@spartacus/storefront';
import {I18nModule, UrlModule} from '@spartacus/core';
import {RouterModule} from '@angular/router';

@NgModule({
  declarations: [
    AccessDeniedPageComponent
  ],
  imports: [
    CommonModule,
    GenericLinkModule,
    MediaModule,
    I18nModule,
    UrlModule,
    RouterModule
  ],
  exports: [
    AccessDeniedPageComponent
  ]
})

export class AccessDeniedPageModule {
}
